"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Billing = void 0;
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
var prop_types_1 = __importDefault(require("prop-types"));
function Billing(_a) {
    var channel = _a.channel;
    var numbers = react_1.useState({
        subscriptions: 250.00,
        pay_per_views: 250.00,
        transaction: 125.00,
        platform: 125.00,
    })[0];
    var billings = ra_fetch_1.useApi('ecommerce').index('billings', {
        channel_id: channel.id,
        sort: ['year desc', 'month desc'],
    })[0];
    var billing = billings.data[0] || {};
    if (billings.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    var final = billings.data.filter(function (billing) { return billing.final; });
    return react_1.default.createElement(storybook_1.Layouts.Container, { className: 'storybook-layouts-space' },
        billing.id && react_1.default.createElement("div", { className: 'rounded bg-white mb-sm' },
            react_1.default.createElement(storybook_1.Billings.Summary, { numbers: numbers, billing: billing }),
            react_1.default.createElement(storybook_1.Billings.Divider, null),
            react_1.default.createElement(storybook_1.Billings.Calculation, { billing: billing })),
        Boolean(final.length) && react_1.default.createElement(storybook_1.Billings.History, { channel: channel, billings: final }));
}
exports.Billing = Billing;
Billing.propTypes = {
    /**
     * Current channel session
     */
    channel: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
        name: prop_types_1.default.string.isRequired,
    }).isRequired,
};
